var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgLogoSmall = function SvgLogoSmall(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 486 447",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    role: "img",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Group_2299"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2297"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_550",
    d: "M29.396,60.689c-16.12,0 -29.396,-12.327 -29.396,-28.448l0,-1.896c0,-16.121 12.327,-30.345 29.396,-30.345l0.949,0c17.068,0 30.344,13.276 30.344,30.345c0,17.068 -13.276,30.344 -30.344,30.344l-0.949,0Z",
    style: {
      fill: "#62b4f6",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2298"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_551",
    d: "M58.489,349.503l-24.655,-0c-13.276,-0 -24.655,-11.38 -24.655,-24.655l0,-201.981c0,-10.431 6.638,-19.914 17.069,-23.707c13.276,-4.741 27.5,2.845 31.293,16.121c0.948,2.845 0.948,4.741 0.948,7.586l0,226.636Z",
    style: {
      fill: "#62b4f6",
      fillRule: "nonzero"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2302"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2300"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_552",
    d: "M456.021,446.491c-17.068,0 -30.344,-14.224 -30.344,-30.344c-0,-17.069 14.224,-30.345 30.344,-30.345c16.121,0 29.397,12.328 29.397,28.448l-0,1.897c-0,16.12 -12.328,30.344 -29.397,30.344c0.949,0 0.949,0 0,0Zm0,-96.723c-13.275,0 -24.655,-11.379 -24.655,-24.655l0,-226.636l24.655,0c14.224,0 24.655,11.38 24.655,24.655l0,201.981c0.949,13.276 -10.431,24.655 -24.655,24.655Z",
    style: {
      fill: "#7ae189",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2301"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_553",
    d: "M271.299,354.889c-53.103,-0 -77.758,-37.931 -77.758,-73.017c-0.948,-21.81 7.586,-42.672 22.759,-57.844c23.706,-23.707 67.327,-36.982 125.171,-36.982l-0,-2.845c0.948,-15.172 -3.793,-29.396 -14.224,-40.776c-10.431,-9.482 -25.603,-14.224 -39.827,-13.275c-17.069,-0 -33.19,3.793 -49.31,10.431c-4.742,1.896 -9.483,1.896 -14.224,-0c-4.742,-1.897 -8.535,-5.69 -10.431,-10.431c-2.845,-8.535 0.948,-18.017 9.482,-21.811c21.811,-10.43 46.466,-15.172 70.172,-15.172c79.655,0 95.775,55.948 95.775,102.413l0,91.982c0,15.172 0.948,29.396 1.897,41.724c0.948,9.482 -6.638,18.965 -16.121,19.913l-10.431,0c-9.482,0 -17.069,-6.638 -18.017,-16.12l0,-12.328c-18.965,21.81 -46.465,35.086 -74.913,34.138Zm57.844,-130.861c-57.844,1.897 -86.292,19.914 -86.292,53.103c-1.896,19.914 13.276,37.931 33.189,39.827l5.69,0c25.603,0.948 49.31,-15.172 57.844,-39.827c0.949,-4.741 1.897,-8.534 1.897,-13.276l-0,-27.5c-0,-3.793 -1.897,-6.637 -3.793,-9.482c-1.897,-1.897 -4.742,-2.845 -8.535,-2.845Z",
    style: {
      fill: "#7ae189",
      fillRule: "nonzero"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2303"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_554",
    d: "M87.307,349.806l-2.845,0c-3.793,-0.948 -4.741,-4.741 -3.793,-8.534l92.93,-238.964c0.948,-3.793 4.741,-4.741 8.535,-3.793c3.793,0.949 4.741,4.742 3.793,8.535l-92.93,238.015c-0.949,1.896 -1.897,2.845 -3.794,3.793c0,0.948 -0.948,0.948 -1.896,0.948Z",
    style: {
      fill: "#7ae189",
      fillRule: "nonzero"
    }
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgLogoSmall);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/logo_small.b142c9c175e26382e0967043fec39a59.svg";